import ApplyToCollaborateMessage from "%/dynamic-component-editor/standard-pages/apply-to-collaborate-page/ApplyToCollaborateMessage.vue";
import ApplyToCollaborateButton from "%/dynamic-component-editor/standard-pages/apply-to-collaborate-page/ApplyToCollaborateButton.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyApplyToCollaborate extends LegacyEntity {
  get elements() {
    return {
      ApplyToCollaborateMessage,
      ApplyToCollaborateButton,
    };
  }
}
